import { IComponent } from '../../../interfaces';
import BaseInput from './base-input';
import { useProps } from '../../../hooks/use-props';

export interface IInputProps {
  id: string;
  type?: string;
  label?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  customTransformation?: (value: string) => string;
  error?: string;
  required?: boolean;
  className?: string;
  onBlur?: () => void;
  mask?: string;
  disabled?: boolean;
  in_review?: boolean;
  step?: number;
  min?: number;
  max?: number;
  clearValue?: boolean;
}

interface IInputAtom extends IComponent {
  value?: string;
  answer: string;
  error?: string;
  mask?: string;
}

const useInput = (id: string) => {
  const { props, addAnswer, validate } = useProps<IInputAtom>({ id, initial_state: '' });

  const setValue = (answer: string) => {
    addAnswer({ answer });
  };

  return { props, onBlur: () => validate(id), setValue };
};

const Input = ({ id }: IInputProps) => {
  const {
    props: { label = '', value, error, show, required, variant, mask },
    setValue,
    onBlur,
  } = useInput(id);
  if (!show) return null;
  return (
    <BaseInput
      id={id}
      type={variant}
      label={label}
      value={value}
      mask={mask}
      onChange={(value) => setValue(value)}
      onBlur={onBlur}
      error={error}
      required={required}
    />
  );
};

export default Input;
